import React from "react";

import DrawerActionButton from "@is/components/DrawerActionButton";
import { Logo } from "@is/components/Logo";
import Passcode from "@is/components/Passcode";

import css from "./PasscodeView.module.css";
import useManagePasscodeView from "./hooks/useManagePasscodeView";

type Props = {
  maskedPasscode: string[];
};

const PasscodeView = ({ maskedPasscode }: Props) => {
  const { isScrolled, handleClose, handleScroll, handlePasscodeViewClose, t } =
    useManagePasscodeView();

  return (
    <div>
      <DrawerActionButton onClick={handleClose} isScrolled={isScrolled} />
      <div className={css.container} onScroll={handleScroll}>
        <div className={css.header}>
          <h1 className="text-headline-5xl">{t("Enter your passcode")}</h1>
        </div>
        <div className={css.content}>
          <Passcode
            maskedPasscode={maskedPasscode}
            onPasscodeViewClose={handlePasscodeViewClose}
          />
        </div>
        <Logo className={css.footer} />
      </div>
    </div>
  );
};

export default PasscodeView;
